"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfirmDialogVM = exports.ConfirmDialogPM = void 0;
const Entities_1 = require("../../Entities");
class ConfirmDialogPM {
    updateAlertObserver(alert) {
        if (alert === this.observingAlert)
            return;
        if (this.observingAlert !== null) {
            this.observingAlert.removeObserver(this.doUpdateView);
        }
        if (alert !== null) {
            alert.addObserver(this.doUpdateView);
        }
        this.observingAlert = alert;
    }
    vmHasChanged(vm) {
        if (this.lastVM === undefined)
            return true;
        if (vm.cancelButtonLabel === this.lastVM.cancelButtonLabel &&
            vm.message === this.lastVM.message &&
            vm.title === this.lastVM.title) {
            return false;
        }
        return true;
    }
    constructor(repo, updateView) {
        this.repo = repo;
        this.updateView = updateView;
        this.observingAlert = null;
        this.doUpdateView = () => {
            let vm = {
                message: "",
                title: "",
                cancel: () => {
                    console.warn("[ConfirmDialogVM.cancel] empty VM!");
                },
                cancelButtonLabel: "",
                confirm: () => {
                    console.warn("[ConfirmDialogVM.confirm] empty VM!");
                },
                confirmButtonLabel: ""
            };
            if (this.repo.activeDialog &&
                this.repo.activeDialog.type === Entities_1.confirmDialogType) {
                const alertDialog = this.repo.activeDialog;
                this.updateAlertObserver(alertDialog);
                vm = {
                    cancelButtonLabel: alertDialog.cancelButtonLabel,
                    confirmButtonLabel: alertDialog.confirmButtonLabel,
                    cancel: alertDialog.cancel,
                    confirm: alertDialog.confirm,
                    message: alertDialog.message,
                    title: alertDialog.title,
                };
            }
            else {
                this.updateAlertObserver(null);
            }
            if (!this.vmHasChanged(vm))
                return;
            this.updateView(vm);
            this.lastVM = vm;
        };
        this.dispose = () => {
            this.repo.removeObserver(this.doUpdateView);
            if (this.observingAlert) {
                this.observingAlert.removeObserver(this.doUpdateView);
            }
        };
        repo.addObserver(this.doUpdateView);
        this.doUpdateView();
    }
}
exports.ConfirmDialogPM = ConfirmDialogPM;
exports.defaultConfirmDialogVM = {
    message: "",
    title: "",
    cancel: () => {
        console.warn("[ConfirmDialogVM.cancel] default VM!");
    },
    cancelButtonLabel: "",
    confirm: () => {
        console.warn("[ConfirmDialogVM.confirm] default VM!");
    },
    confirmButtonLabel: ""
};
